var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg042Home(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 8V20C3 20.5523 3.44772 21 4 21H9C9.55228 21 10 20.5523 10 20V13H14V20C14 20.5523 14.4477 21 15 21H20C20.5523 21 21 20.5523 21 20V8C21 7.68524 20.8518 7.38885 20.6 7.2L12.6 1.2C12.2444 0.933333 11.7556 0.933333 11.4 1.2L3.4 7.2C3.14819 7.38885 3 7.68524 3 8ZM5 8.5L12 3.25L19 8.5V19H16V12C16 11.4477 15.5523 11 15 11H9C8.44772 11 8 11.4477 8 12V19H5V8.5Z",
    fill: "#04334E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg042Home);
export default __webpack_public_path__ + "static/media/042-home.098d906a3ade5ad20d0b36737fc9cf08.svg";
export { ForwardRef as ReactComponent };